// TanStack Router setup — Phase G1.
//
// Bootstraps the file-based routes generated by TanStackRouterVite
// from src/routes/*. The generated routeTree.gen.ts is regenerated
// on save by the Vite plugin in dev and at build time in prod.
//
// Client-only (no @tanstack/react-start) — pencilwise stays a Vercel
// SPA. Phase G2 will add Tailwind; Phase G3 will port storybook
// screens into this route tree.

import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { SurfaceRouteError } from "./components/RouterErrorFallback";
import { captureRenderError } from "./lib/sentry";
import { makeRouteOnCatch } from "./lib/routeOnCatch";

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  // MA-160: route crashes must render OUR fallback (with the data-app-crashed
  // marker the live-QA net detects), never TanStack's built-in error screen.
  defaultErrorComponent: SurfaceRouteError,
  // MA-107: a route crash is caught by the route's CatchBoundary and never
  // reaches the root ErrorBoundary (the only other captureRenderError caller),
  // so Sentry saw none of them. No-op in dev / when Sentry is not initialised.
  defaultOnCatch: makeRouteOnCatch(captureRenderError),
});

// Register the router instance type for type-safe Link / useNavigate.
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
